import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDetailsTransactionsDetailControllerModule } from './controllers/OrdersTransactionsDetailController';

export const OrderDetailsTransactionsDetailView = angular
  .module('acme.view.application.orders.detail.transactions.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    OrderDetailsTransactionsDetailControllerModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersTransactionsDetail = {
      name: 'application.orders.detail.transactions.detail',
      url: '/:id',
      views: {
        'subview-main@application.orders': {
          controller: 'OrdersTransactionsDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/transactions/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Transaction Details',
        permissions: ['ORDER_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(ordersTransactionsDetail);
  }).name;
